require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-5-ways-to-boost-your-financial-health-amidst-covid-19.json") })
        }
      }, "path---es-articles-5-ways-to-boost-your-financial-health-amidst-covid-19");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-5-ways-to-boost-your-financial-health-amidst-covid-19!./.cache/json/es-articles-5-ways-to-boost-your-financial-health-amidst-covid-19.json
// module id = 2027
// module chunks = 231608221292675